import { FRAXLEND_PAIR_ABI } from '@/config/abis/FraxlendPair.abi'
import { toBigInt } from '@/utils/bigNumber'
import { ActionConfig, ActionContext } from '../../../logic/types'
import { ensureConfigTypes } from '@/domain/hooks/useWrite'
import { IsolatedDepositAction } from '../types'
import { getPortfolioBalanceInvalidationKeys } from '@/features/actions/logic/invalidation'

export function createIsolatedDepositActionConfig(action: IsolatedDepositAction, context: ActionContext): ActionConfig {
  const { account, chainId, isolatedInfo } = context

  return {
    getWriteConfig: () => {
      const depositAmount = toBigInt(action.token.toBaseUnit(action.value))

      return ensureConfigTypes({
        abi: FRAXLEND_PAIR_ABI,
        address: isolatedInfo?.pairAddress,
        functionName: 'addCollateral',
        chainId,
        args: [depositAmount, account],
      })
    },

    invalidates: () => getPortfolioBalanceInvalidationKeys({ account, chainId }),
  }
}
